import { observer } from "mobx-react";
import BasePageLayout from "../../../../components/layouts/base-page-layout/base-page-layout";
import TranslationScope from "../../../../translation/translation-scope";
import { Outlet } from "react-router-dom";
import useExpandCollapse from "../../../../hooks/expand-collapse-hook";
import { useEffect } from "react";
import currentPortalStore from "../../../../stores/current-portal-store";
import { APP_PATHS } from "../../../../constants/app-paths";
import TranslateButtonSPA from "../../../../components/translate-button/TranslateButtonSPA";

const PortalsContentSettingsPage: React.FC = observer(() => {
    const expandCollapseStore = useExpandCollapse();

    useEffect(() => {
        currentPortalStore.load();
    }, []);

    return (
        <TranslationScope scope="assistant">
            <BasePageLayout title="Settings" subTitles={['Portal', 'Content']}
                instruction="Customize the texts that appear on your portals, in each of your languages.">

                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 0 10px 0' }}>
                    <TranslateButtonSPA path={APP_PATHS.RETURN_PORTAL_LOCALIZATION} />
                </div>
                
                <Outlet context={expandCollapseStore} />

            </BasePageLayout>
        </TranslationScope>
    );
});

export default PortalsContentSettingsPage;